export const FETCH_CLAIM_DROPDOWN_REQUEST = 'FETCH_CLAIM_DROPDOWN_REQUEST';
export const FETCH_CLAIM_DROPDOWN_SUCCESS = 'FETCH_CLAIM_DROPDOWN_SUCCESS';
export const FETCH_CLAIM_DROPDOWN_FAILURE = 'FETCH_CLAIM_DROPDOWN_FAILURE';

export const SAVE_EXTRA_DUTY_CLAIM_REQUEST = "SAVE_EXTRA_DUTY_CLAIM_REQUEST";
export const SAVE_EXTRA_DUTY_CLAIM_SUCCESS = "SAVE_EXTRA_DUTY_CLAIM_SUCCESS";
export const SAVE_EXTRA_DUTY_CLAIM_FAILURE = "SAVE_EXTRA_DUTY_CLAIM_FAILURE";

// Extra Duty Approvals
export const SAVE_EXTRA_DUTY_APPROVAL_REQUEST = "SAVE_EXTRA_DUTY_APPROVAL_REQUEST";
export const SAVE_EXTRA_DUTY_APPROVAL_SUCCESS = "SAVE_EXTRA_DUTY_APPROVAL_SUCCESS";
export const SAVE_EXTRA_DUTY_APPROVAL_FAILURE = "SAVE_EXTRA_DUTY_APPROVAL_FAILURE";

export const FETCH_EXTRA_DUTY_APPROVAL_DETAIL_LIST_REQUEST = "FETCH_EXTRA_DUTY_APPROVAL_DETAIL_LIST_REQUEST";
export const FETCH_EXTRA_DUTY_APPROVAL_DETAIL_LIST_SUCCESS = "FETCH_EXTRA_DUTY_APPROVAL_DETAIL_LIST_SUCCESS";
export const FETCH_EXTRA_DUTY_APPROVAL_DETAIL_LIST_FAILURE = "FETCH_EXTRA_DUTY_APPROVAL_DETAIL_LIST_FAILURE";

export const FETCH_EXTRA_DUTY_APPROVALS_REQUEST = "FETCH_EXTRA_DUTY_APPROVALS_REQUEST";
export const FETCH_EXTRA_DUTY_APPROVALS_SUCCESS = "FETCH_EXTRA_DUTY_APPROVALS_SUCCESS";
export const FETCH_EXTRA_DUTY_APPROVALS_FAILURE = "FETCH_EXTRA_DUTY_APPROVALS_FAILURE";

export const FETCH_PUNCH_DETAILS_REQUEST = "FETCH_PUNCH_DETAILS_REQUEST";
export const FETCH_PUNCH_DETAILS_SUCCESS = "FETCH_PUNCH_DETAILS_SUCCESS";
export const FETCH_PUNCH_DETAILS_FAILURE = "FETCH_PUNCH_DETAILS_FAILURE";

export const SAVE_EXTRA_DUTY_CANCEL_REQUEST = "SAVE_EXTRA_DUTY_CANCEL_REQUEST";
export const SAVE_EXTRA_DUTY_CANCEL_SUCCESS = "SAVE_EXTRA_DUTY_CANCEL_SUCCESS";
export const SAVE_EXTRA_DUTY_CANCEL_FAILURE = "SAVE_EXTRA_DUTY_CANCEL_FAILURE";

export const FETCH_EXTRA_DUTY_CANCEL_DETAIL_LIST_REQUEST = "FETCH_EXTRA_DUTY_CANCEL_DETAIL_LIST_REQUEST";
export const FETCH_EXTRA_DUTY_CANCEL_DETAIL_LIST_SUCCESS = "FETCH_EXTRA_DUTY_CANCEL_DETAIL_LIST_SUCCESS";
export const FETCH_EXTRA_DUTY_CANCEL_DETAIL_LIST_FAILURE = "FETCH_EXTRA_DUTY_CANCEL_DETAIL_LIST_FAILURE";

export const FETCH_EXTRA_DUTY_CANCELS_REQUEST = "FETCH_EXTRA_DUTY_CANCELS_REQUEST";
export const FETCH_EXTRA_DUTY_CANCELS_SUCCESS = "FETCH_EXTRA_DUTY_CANCELS_SUCCESS";
export const FETCH_EXTRA_DUTY_CANCELS_FAILURE = "FETCH_EXTRA_DUTY_CANCELS_FAILURE";

export const FETCH_EXTRA_DUTY_PAYMENT_CLAIM_LIST_REQUEST = "FETCH_EXTRA_DUTY_PAYMENT_CLAIM_LIST_REQUEST";
export const FETCH_EXTRA_DUTY_PAYMENT_CLAIM_LIST_SUCCESS = "FETCH_EXTRA_DUTY_PAYMENT_CLAIM_LIST_SUCCESS";
export const FETCH_EXTRA_DUTY_PAYMENT_CLAIM_LIST_FAILURE = "FETCH_EXTRA_DUTY_PAYMENT_CLAIM_LIST_FAILURE";

export const CONVERT_PAYMENT_REQUEST = "CONVERT_PAYMENT_REQUEST";
export const CONVERT_PAYMENT_SUCCESS = "CONVERT_PAYMENT_SUCCESS";
export const CONVERT_PAYMENT_FAILURE = "CONVERT_PAYMENT_FAILURE";

export const FETCH_EXTRA_DUTY_PAYMENT_CLAIM_APPROVAL_LIST_REQUEST = "FETCH_EXTRA_DUTY_PAYMENT_CLAIM_APPROVAL_LIST_REQUEST";
export const FETCH_EXTRA_DUTY_PAYMENT_CLAIM_APPROVAL_LIST_SUCCESS = "FETCH_EXTRA_DUTY_PAYMENT_CLAIM_APPROVAL_LIST_SUCCESS";
export const FETCH_EXTRA_DUTY_PAYMENT_CLAIM_APPROVAL_LIST_FAILURE = "FETCH_EXTRA_DUTY_PAYMENT_CLAIM_APPROVAL_LIST_FAILURE";

export const FETCH_EXTRA_DUTY_PAYMENT_CLAIM_CANCEL_LIST_REQUEST = "FETCH_EXTRA_DUTY_PAYMENT_CLAIM_CANCEL_LIST_REQUEST";
export const FETCH_EXTRA_DUTY_PAYMENT_CLAIM_CANCEL_LIST_SUCCESS = "FETCH_EXTRA_DUTY_PAYMENT_CLAIM_CANCEL_LIST_SUCCESS";
export const FETCH_EXTRA_DUTY_PAYMENT_CLAIM_CANCEL_LIST_FAILURE = "FETCH_EXTRA_DUTY_PAYMENT_CLAIM_CANCEL_LIST_FAILURE";

export const CANCEL_PAYMENT_REQUEST = "CANCEL_PAYMENT_REQUEST";
export const CANCEL_PAYMENT_SUCCESS = "CANCEL_PAYMENT_SUCCESS";
export const CANCEL_PAYMENT_FAILURE = "CANCEL_PAYMENT_FAILURE";

// Manual Punch
export const FETCH_MANUAL_PUNCH_LIST_REQUEST = "FETCH_MANUAL_PUNCH_LIST_REQUEST";
export const FETCH_MANUAL_PUNCH_LIST_SUCCESS = "FETCH_MANUAL_PUNCH_LIST_SUCCESS";
export const FETCH_MANUAL_PUNCH_LIST_FAILURE = "FETCH_MANUAL_PUNCH_LIST_FAILURE";

export const SAVE_MANUAL_PUNCH_REQUEST = "SAVE_MANUAL_PUNCH_REQUEST";
export const SAVE_MANUAL_PUNCH_SUCCESS = "SAVE_MANUAL_PUNCH_SUCCESS";
export const SAVE_MANUAL_PUNCH_FAILURE = "SAVE_MANUAL_PUNCH_FAILURE";

export const DELETE_MANUAL_PUNCH_REQUEST = "DELETE_MANUAL_PUNCH_REQUEST";
export const DELETE_MANUAL_PUNCH_SUCCESS = "DELETE_MANUAL_PUNCH_SUCCESS";
export const DELETE_MANUAL_PUNCH_FAILURE = "DELETE_MANUAL_PUNCH_FAILURE";
